




<template>
  <app-modalData :init = "metaData"  @f="f($event)" v-if="metaData" >
    <div slot="operations" style="margin:15px;border:solid #E3E4E8 1px;padding:5px;border-radius:3px">
    <v-textarea  v-model="resources" color="#4A76A8" label="Список IDS через запятую">

    </v-textarea>
      <v-btn  @click="resourcesAdd()" block small color="#4A76A8"  class="white--text" >Добавить ресурсы</v-btn>
        <v-btn @click="resourcesDeleteAll()"  block small color="red"  class="white--text" >Удалить все ресурсы </v-btn>
      <v-btn @click="resourcesDeleteSelected()" v-if="tasks.task.resources.foundData.selectedIds.length>0" block small color="red"  class="white--text" >Удалить {{tasks.task.resources.foundData.selectedIds.length}} </v-btn>
    </div>
  </app-modalData>
</template>

<script>

import axios from 'axios'
export default {
props:['tasks' ],
  data () {
    return {


      modalData:{
       sb: {
         snackbar: false,
         color: 'success',
         text: ''
       },
       f: "",
       selectedItem: "non_done",
         header:{
           text:"",
            icon:"mdi-database",
           icons:[
             {
               name:"mdi-close",
               f:"close",
             },
           ]
         },
       bar: {
           items:[
             {
                itemName: 'non_done',
                text:'в очереди',
                f: null,
                selectedColor: 'green',
                color: '#4A76A8',
             },
             {
                itemName: 'before_done',
                text:'обработанные',
                f: null,

             },

           ],
           status: ""
         },
       content:{
         type:'groups',
           items:{

               non_done:{
                 foundData: {},
                 meneger:{}
               },


               before_done:{
                 foundData: {},
                 meneger:{}
               }

           },
         },


       operations:{

       }

      },



  resources: null,



       contentMenegment: {
         marginTop: '0px',
         snackbarAbsoute: true,
         items: {
           selector: {active:true},
           copy: {active:true},
           export: {active:true},
           update: {active:false},
           delete: {active:false},
           autoExport: {active:false},

         },
         contentInfo: {
           type: 'groups',
         },
         autoExport: {
           isActive: false,
           tasksList:[],

         }

        },


       contentMenegmentDone: {
         marginTop: '0px',
         snackbarAbsoute: true,
         items: {
           selector: {active:true},
           copy: {active:true},
           export: {active:true},
           update: {active:false},
           delete: {active:false},
           autoExport: {active:false},

         },
         contentInfo: {
           type: 'groups',
         },
         autoExport: {
           isActive: false,
           tasksList:[],

         }

        },

    }
  },
methods:{

  f(fName){
  eval('this.'+fName+'()')
  },

  close(){
    this.tasks.modals.resources = false
  },

  resourcesAdd(){

  if(this.resources == null){
    this.modalData.sb.color = "error"
    this.modalData.sb.text = "список IDS пуст"
     this.modalData.sb.snackbar = true
  } else {
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:  [this.tasks.task.info.task_id],
           data:  this.resources.split(','),
           frontEnd: this.tasks.task.info.task_id
         }
       })
       .then( response => {
         //this.init.loadingMore = false
          this.modalData.sb.color = "success"
          this.modalData.sb.text = response.data.success
          this.modalData.sb.snackbar = true
          this.tasks.task.resources.foundData.foundIds = this.tasks.task.resources.foundData.foundIds.concat(response.data.ids.split(','))
          this.resources = null

       })

  }


  },


resourcesDeleteAll(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
       method: 'POST',
       data: {
         taskIds:   this.tasks.task.info.task_id ,
         deleteAll:  1,

       }
     })
     .then( response => {

if(response.data.success == 'Список ресурсов очищен'){
  this.tasks.task.resources.foundData.selector = false
  this.tasks.task.resources.foundData.foundIds = []
  this.tasks.task.resources.foundData.displayIds = []
  this.tasks.task.resources.foundData.selectedIds = []
  this.tasks.task.resources.foundData.offset = 0
  this.tasks.task.resources.foundData.selectAll = false

  //this.init.loadingMore = false
   this.modalData.sb.color = "success"
   this.modalData.sb.text = response.data.success
   this.modalData.sb.snackbar = true
   this.resources = ""


}


     })

},

resourcesDeleteSelected(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
       method: 'POST',
       data: {
         taskIds:   this.tasks.task.info.task_id ,
         deleteSelected :  1,
         ids : this.tasks.task.resources.foundData.selectedIds
       }
     })
     .then( response => {

if(response.data.success == "Список ресурсов изменен"){


  this.tasks.task.resources.foundData.selector = false
  this.tasks.task.resources.foundData.foundIds = []
  this.tasks.task.resources.foundData.foundIds = this.tasks.task.resources.foundData.foundIds.concat(response.data.resources)
  this.tasks.task.resources.foundData.displayIds = []
  this.tasks.task.resources.foundData.selectedIds = []
  this.tasks.task.resources.foundData.offset = 0
  this.tasks.task.resources.foundData.selectAll = false


  console.log(this.tasks.task.resources.foundData.foundIds)


  //this.init.loadingMore = false
   this.sb.color = "success"
   this.sb.text = response.data.success
   this.sb.snackbar = true
   this.resources = ""


}


     })

},



},
created(){

  this.modalData.header.text =  "ghbdtn"// this.tasks.task.info.name

  this.modalData.content.items.non_done.foundData = this.tasks.task.resources.foundData
  this.modalData.content.items.non_done.meneger = this.contentMenegment

  this.modalData.content.items.before_done.foundData = this.tasks.task.resources.foundDataDone
  this.modalData.content.items.before_done.meneger = this.contentMenegmentDone

},

computed: {
metaData(){
  if(this.tasks.modals.resources){

    this.modalData.header.text = this.tasks.task.info.name

    this.modalData.content.type = this.tasks.task.info.content_type

    this.contentMenegment.contentInfo.type = this.tasks.task.info.content_type
    this.contentMenegmentDone.contentInfo.type = this.tasks.task.info.content_type

    this.modalData.content.items.non_done.foundData = this.tasks.task.resources.foundData
    this.modalData.content.items.non_done.meneger = this.contentMenegment

    this.modalData.content.items.before_done.foundData = this.tasks.task.resources.foundDataDone
    this.modalData.content.items.before_done.meneger = this.contentMenegmentDone




    return this.modalData
  } else return false
  },

},


beforeDestroy() {

}

}
</script>

<style   >

</style>
